import { render, staticRenderFns } from "./entry-category-table.vue?vue&type=template&id=c90ff6ac&scoped=true&"
import script from "./entry-category-table.ts?vue&type=script&lang=ts&"
export * from "./entry-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./entry-category-table.scss?vue&type=style&index=0&id=c90ff6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90ff6ac",
  null
  
)

export default component.exports